import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

export default function TrendChart({ history = [] }) {
  const hasConfidence = history.some((h) => typeof h.confidence_pct === "number");
  return (
    <div className="pp-surface p-5" data-testid="trend-chart">
      <div className="pp-label mb-1">12-week Trend</div>
      <div className="font-display text-lg text-white mb-4">
        Trust compounds week after week.
      </div>
      <div style={{ width: "100%", height: 300, minHeight: 260 }}>
        <ResponsiveContainer width="100%" height="100%" minWidth={0}>
          <LineChart data={history} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="#333C47" strokeDasharray="0 0" vertical={false} />
            <XAxis
              dataKey="date"
              tick={{ fill: "#C7CBD1", fontSize: 10 }}
              tickFormatter={(v) => v.slice(5)}
              stroke="#333C47"
            />
            <YAxis
              domain={[0, 100]}
              tick={{ fill: "#C7CBD1", fontSize: 10 }}
              stroke="#333C47"
            />
            <Tooltip
              contentStyle={{
                background: "#232931",
                border: "1px solid #333C47",
                borderRadius: 4,
                color: "#FFFFFF",
              }}
            />
            {hasConfidence && (
              <Legend
                verticalAlign="top"
                height={24}
                iconType="plainline"
                wrapperStyle={{ color: "#C7CBD1", fontSize: 10 }}
              />
            )}
            <Line
              name="Trust Score"
              type="monotone"
              dataKey="score"
              stroke="#6CC24A"
              strokeWidth={2}
              dot={{ r: 3, fill: "#6CC24A", stroke: "#0F1115", strokeWidth: 1 }}
              activeDot={{ r: 5 }}
            />
            {hasConfidence && (
              <Line
                name="Evidence confidence"
                type="monotone"
                dataKey="confidence_pct"
                stroke="#C7CBD1"
                strokeWidth={1.5}
                strokeDasharray="4 4"
                dot={false}
                activeDot={{ r: 4 }}
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
